import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_WHITE } from "../lib/api";

const LINKS = [
    { to: "/produzioni-tv", label: "Produzioni TV" },
    { to: "/eventi", label: "Eventi" },
    { to: "/comunicazione", label: "Comunicazione" },
    { to: "/casting", label: "Casting" },
    { to: "/talent-ospiti", label: "Talent & Ospiti" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    const isDarkHeroPage = ["/", "/produzioni-tv", "/format-tv", "/eventi", "/talent-ospiti", "/comunicazione", "/casting", "/contatti"].some(
        (p) => location.pathname === p || location.pathname.startsWith(p + "/")
    );

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled || open ? "bg-black/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
            }`}
        >
            <div className="container-nm flex items-center justify-between h-[72px] md:h-[84px] text-white">
                <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="nav-logo">
                    <img src={LOGO_WHITE} alt="N&M Management" className="h-9 md:h-10 w-auto" />
                </Link>

                <nav className="hidden lg:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.to.replace("/", "")}`}
                            className={({ isActive }) =>
                                `nav-link ${isActive ? "active text-white" : "text-white/75"}`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <Link
                        to="/contatti"
                        data-testid="nav-cta-contact"
                        className="hidden md:inline-flex items-center px-5 py-2.5 text-sm font-semibold border border-white/40 hover:bg-white hover:text-black transition-all duration-300"
                    >
                        Contattaci
                    </Link>
                    <button
                        className="lg:hidden p-2 -mr-2"
                        onClick={() => setOpen(!open)}
                        data-testid="nav-mobile-toggle"
                        aria-label="Menu"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl" data-testid="mobile-menu">
                    <div className="container-nm py-8 flex flex-col gap-5 text-white">
                        {LINKS.map((l) => (
                            <Link
                                key={l.to}
                                to={l.to}
                                className="text-2xl font-display font-bold tracking-tight"
                                onClick={() => setOpen(false)}
                            >
                                {l.label}
                            </Link>
                        ))}
                        <Link
                            to="/contatti"
                            className="mt-4 btn-primary self-start"
                            onClick={() => setOpen(false)}
                        >
                            Contattaci
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
